import VueMonthlyPicker from 'vue-monthly-picker';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import store from "@/store";
import CONFIG from "@/assets/js/config.js";

export default {
  name: "paymentDetail",
  components: {
    MainLayout,
    VueMonthlyPicker,
    Loading
  },

  data() {
    return {
      paymentData: [],
      paymentInfo: [],
      campusId: store.state.user.campus_id,
      paymentMethodArr: null,
      isLoading: false,
      student_name: '',
      config: CONFIG,
      paymentStatus: null,
    };
  },

  methods: {
    getPaymentMethod() {
      axios.get('getPaymentMethod')
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Payment Method'
          }];
          this.paymentMethodArr = $defaultSelectOption.concat(res.data);
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getDetail() {
      axios.get('payment/detail/' + this.$route.params.invoiceId, {
        params: {
          class_id: this.$route.params.classId,
          campus_id: store.state.user.campus_id
        }
      }).then(res => {
        if(res.data.length == 0){
          this.$notification.error("This payment does not exist on this campus", {
              timer: 3,
              position: "bottomCenter"
          });
          this.$router.push({
              name: "paymentList"
          });
        }else{
          this.paymentData = res.data;
          this.paymentInfo = this.paymentData.payment_data;
          this.student_name = res.data.studentName;
          this.paymentStatus = CONFIG.PAYMENT_STATUSES_OPTIONS.find(option => option.id == this.paymentInfo.status).text;
          this.isLoading = false;
        }
      })
      .catch(error => {
        this.isLoading = false;
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      })
    },

    sendNotification(){
      var msg = "Are you sure you want to send payment notification to student?";                        
        if (window.confirm(msg)) { 
          this.isLoading = true;
          var request = {
              campus_id: this.$store.state.user.campus_id,
              payment_id: this.paymentInfo.id,
          }
          axios.post('payment/send-notification', request)
            .then(res => {
              this.isLoading = false;
              if (res.data.success == true) {
                this.paymentInfo.notice_status = 1;
                this.$notification.success("Payment Notification Send Successfully", {
                  timer: 3,
                  position: "bottomCenter"
                });
              }
            }).catch((error) => {
              this.isLoading = false;
              const errorMessage = error.response?.data?.message || "Failed to send payment notification.";
              this.$notification.error(errorMessage, {
                  timer: 3,
                  position: "bottomCenter",
              });
              if (error.response && error.response.status == 401) {
                this.$store.commit('logout');
                window.location.replace('login');
              }
            });
        }
    },

    pdfDownload(studentName, paymentId) {
      this.isLoading = true;
      var request;
      request = {
        params: {
          campus_id: this.campusId,
          payment_id: paymentId,
          class_id: this.paymentData.class_id
        },
        responseType: 'blob'
      }
      axios.get("/payment/pdfDownload/" + this.paymentData.student_id, request, {
        headers: {
          'Content-Type': 'application/pdf',
        }
      })
      .then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        let date = new Date();
        const fileName = `invoice_${studentName}_${date.getFullYear()}${(date.getMonth() + 1) > 9 ? '' : '0'}${date.getMonth()+1}${(date.getDate()) > 9 ? '' : '0'}${date.getDate()}.pdf`;
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.isLoading = false;
      }).catch(error => {
        if (error.response.status == 401) {
         this.$store.commit('logout');
         window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    openImage(imagePath) {
      window.open(imagePath, '_blank');
    },
  },

  mounted() {
    this.isLoading = true;
    this.getDetail();
    this.getPaymentMethod();
  },
};
